import { render } from "./MostAmazing.vue?vue&type=template&id=6d6fb295&scoped=true"
import script from "./MostAmazing.vue?vue&type=script&lang=js"
export * from "./MostAmazing.vue?vue&type=script&lang=js"

import "./MostAmazing.vue?vue&type=style&index=0&id=6d6fb295&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6fb295"]])

export default __exports__